import { Component, OnInit } from '@angular/core';
import { EditorService } from "../../../editor.service";
@Component({
  selector: 'app-fillupwithoption',
  templateUrl: './fillupwithoption.component.html',
  styleUrls: ['./fillupwithoption.component.css']
})
export class FillupwithoptionComponent implements OnInit {
  multipleSelectData;
  FillUpWidth = 120;
  constructor(private editorService: EditorService) { }
  ngOnInit() {
    let cardData = this.editorService.textInlineData;
    if (cardData && cardData.type == "Select") {
      this.multipleSelectData = cardData;
      this.initializeData(cardData)
    }
  }
  initializeData(cardData) {
    if (cardData.width) {
      this.FillUpWidth = cardData.width;
    }
    if (cardData.allOptions)
      this.FillUpChoiceOptions = cardData.allOptions;
  }

  FillUpChoiceOptions = [{
    name: 'Option 1',
    type: 'Text',
    isValid: true,
    isHovered: false,
    dir: 'ltr'
  }, {
    name: 'Option 2',
    type: 'Text',
    isValid: false,
    isHovered: false,
    dir: 'ltr'
  }];

  //For Updating the fillup Line Width
  updateFillupLineWidth() {
    let com = this.editorService.getIframeReference();
    com.updateFillUpWithOptionsWidth(this.FillUpWidth);
  }


  //For Selecting the Correct Answer
  selectFillUpCorrectOption(ind) {

    if (this.FillUpChoiceOptions[ind] && this.FillUpChoiceOptions[ind].isValid != undefined) {
      this.FillUpChoiceOptions[ind].isValid = !this.FillUpChoiceOptions[ind].isValid;
    }
    for (var i = 0; i < this.FillUpChoiceOptions.length; i++) {
      if (ind == i) {
        this.FillUpChoiceOptions[i].isValid = true;
      } else {
        this.FillUpChoiceOptions[i].isValid = false;
      }
    }
    let com = this.editorService.getIframeReference();
    com.configureSelectAnswer(ind);
  }
  AddMoreFillupOption() {

    let isValid = this.FillUpChoiceOptions.length > 0 ? false : true;
    var obj = {
      name: 'Option  ' + (this.FillUpChoiceOptions.length + 1) + '',
      type: 'Text',
      isValid: isValid,
      isHovered: false,
      hideEdit: false,
      dir: 'ltr',
      imageAlign: {
        type: 'left'
      }
    };
    this.FillUpChoiceOptions.push(obj);
    let com = this.editorService.getIframeReference();
    com.addSelectQestionsOptions();
  }

  //For Changing the option Content
  changeFillUpOptionText(ind) {
    if (this.FillUpChoiceOptions && this.FillUpChoiceOptions[ind]) {
      let com = this.editorService.getIframeReference();
      let optObj: any = {};
      optObj.content = this.FillUpChoiceOptions[ind].name;
      optObj.dir = this.FillUpChoiceOptions[ind].dir;
      com.onEditingSelectOptions(optObj, ind);
    }
  }
  //For Deleting the Option
  deleteFillUpOption(evt, ind) {
    if (this.FillUpChoiceOptions[ind]) {
      this.FillUpChoiceOptions.splice(ind, 1);
      let com = this.editorService.getIframeReference();
      com.removeSelectQestionsOptions(ind);
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/question/fillupwithoption/fillupwithoption.component.ts